import { el } from "../../../../date-fns/locale/el.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    el
  }
};